import { ITrackingUpdate } from '@sdk/contracts';
import { useSearchParams } from 'react-router-dom';

import { useMutateMySubscriptions, useMySubscriptions } from '@/store';
import { getActivityTrace, getNextActivityTrack } from '@/utils';

export const useQuizActivity = () => {
  const { isWorking, updateActivityTrack } = useMutateMySubscriptions();
  const { filteredSubscriptions } = useMySubscriptions();
  const [searchParams] = useSearchParams();

  const subscriptionId = searchParams.get('subscription');
  const activityId = searchParams.get('activity');

  const updateTracking = (trackingData: ITrackingUpdate, onSuccess?: () => void) => {
    const subscription = filteredSubscriptions?.find(s => s._id === subscriptionId);
    if (!subscription) return;
    const metadata = getActivityTrace(subscription, trackingData.activity);

    updateActivityTrack(
      {
        subscriptionId: subscription._id,
        activityTrack: { ...metadata, ...trackingData }
      },
      {
        onSuccess
      }
    );
  };

  const setActivityAsCompleted = () => {
    const subscription = filteredSubscriptions?.find(s => s._id === subscriptionId);
    if (!activityId || !subscription) return;

    const { isCompleted } = getActivityTrackById(activityId);
    if (isCompleted) return;

    updateTracking(
      {
        activity: activityId,
        isCompleted: true
      },
      () => {
        const nextActivityTrack = getNextActivityTrack(subscription, activityId);

        if (!nextActivityTrack) return;
        updateTracking(nextActivityTrack);
      }
    );
  };

  const getActivityTrackById = (activity: string) => {
    const subscription = filteredSubscriptions?.find(s => s._id === subscriptionId);
    const { activityTracking = [] } = subscription || {};
    const currentActivityTrack = activityTracking.find(t => t.activity === activity);

    return {
      ...currentActivityTrack,
      activity
    };
  };

  return {
    isWorking,
    setActivityAsCompleted
  };
};
